import { render } from "./JewelSimulator.vue?vue&type=template&id=206b5c72&scoped=true"
import script from "./JewelSimulator.vue?vue&type=script&lang=js"
export * from "./JewelSimulator.vue?vue&type=script&lang=js"

import "./JewelSimulator.vue?vue&type=style&index=0&id=206b5c72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206b5c72"]])

export default __exports__